/**
 * Build our fields for form
 */
export const getFields = () => {
  return [
    'chooseAccount',
    'chooseAccount.tradingAccount',
    'chooseLicense',
    'chooseLicense.type',
    'licenseDetails',
    'licenseDetails.manufacturer',
    'licenseDetails.product',
    'requiredDate',
    'requiredDate.date',
    'customerDetails',
    'customerDetails.id',
    'customerDetails.name',
    'customerDetails.requestDate',
    'assetDetails',
    'assetDetails.assetNumber',
    'assetDetails.serialNumber',
    'assetDetails.returnKeyCode',
    'newAssetDetails',
    'newAssetDetails.assetNumber',
    'newAssetDetails.serialNumber',
    'poNumber',
    'poNumber.chooseExistingOrNew',
    'poNumber.number',
    'comments',
    'comments.comment',
  ];
};
